<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor">
    <path
      d="M13.78 2.9c0-.5-.4-.9-.9-.9H2.9c-.5 0-.91.4-.91.9v18.16c0 .5.4.91.9.91h9.97c.5 0 .9-.4.9-.9V2.9h.01Zm-1.81 3.94v1.21H6.44v1.82h5.53v1.2H8.9v1.82h3.06v1.21H6.44v1.82h5.53v1.2H8.9v1.82h3.06v1.21H3.82V3.82h8.14v1.2H8.9v1.82h3.05ZM20.34 18.17l-.71.71V5.1l.81.82a.93.93 0 0 0 1.29 0 .9.9 0 0 0 0-1.29l-2.36-2.36a.9.9 0 0 0-1.29 0l-2.36 2.36A.9.9 0 1 0 17 5.92l.82-.82v13.75l-.82-.82a.9.9 0 1 0-1.28 1.28l2.33 2.33c.17.2.4.31.68.31.23 0 .46-.09.64-.26l2.25-2.25a.9.9 0 1 0-1.28-1.28v.01Z"
    />
  </svg>
</template>

<script>
export default {};
</script>
